import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";


import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addSchorHorizontalText, editSchorHorizontalText } from "store/actions";
import { fetchLanguageList } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const TextAddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchSchorHorizontalTextListData, tableData } = props
    const [horizontalSchorTextData, setHorizontalSchorTextData] = useState();
    const [languageList, setLanguageList] = useState();
    const { state } = useLocation();
    const [textTemplate, setTextTemplate] = useState(horizontalSchorTextData?.text);

    const { error, success, loading, editLoading } = useSelector(state => ({
        loading: state.SchorHorizontal.loading,
        error: state.SchorHorizontal.error,
        success: state.SchorHorizontal.success,
        editLoading: state.SchorHorizontal.editLoading,
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setHorizontalSchorTextData(itemData)
    }, [itemData]);

    // fetch language
    const fetchLanguageLists = async () => {
        const listLang = await fetchLanguageList();
        setLanguageList(listLang?.data)
    }

    useEffect(() => {
        fetchLanguageLists()
    }, [])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            language: horizontalSchorTextData?.languageId || languageList && languageList[0]?.id,
            text: horizontalSchorTextData?.text || '',
            is_active: horizontalSchorTextData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            language: Yup.string().required(props.t("Please Enter Language")),
            is_active: Yup.string().required(props.t("Please Enter Text Status")),
        }),
        onSubmit: (values, { resetForm }) => {
            if (!textTemplate) {
                toastr.error(props.t("Please Enter Text"))
                return;
            }
            
            const removePTagFromHtml = textTemplate
                .replace(/<p>/g, '')      // Remove opening <p>
                .replace(/<\/p>/g, '');   // Remove closing </p>

         
         
            values = {
                ...values,
                horizontal_id: state?.horizontalSchorData?.id,
                text: removePTagFromHtml

            }
            if (isEdit) {
                const languageExists = tableData?.horizontal?.some(item => item.languageId == Number(values.language) && values.language != itemData.languageId);
                if (languageExists) {
                    return toastr.error("Horizontal text already exists with the selected language.")
                }

                dispatch(editSchorHorizontalText(values, horizontalSchorTextData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)

                        resetForm({
                            language: '',
                            text: '',
                            is_active: ''
                        });
                        fetchSchorHorizontalTextListData();
                        setTextTemplate()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        setTextTemplate()
                        toggle()

                    }
                }));
            } else {
                const languageExists = tableData?.horizontal?.some(item => item.languageId == values.language);
                if (languageExists) {
                    return toastr.error("Horizontal text already exists with the selected language.")
                }
                dispatch(addSchorHorizontalText(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {

                        resetForm({
                            language: '',
                            text: '',
                            is_active: ''
                        });
                        fetchSchorHorizontalTextListData()
                        toastr.success(res.message)
                        setTextTemplate()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        setTextTemplate()
                        toggle()

                    }
                }));
            }
        }
    });


    const editorConfiguration = {
        placeholder: props.t("Enter Text"),
        toolbar: ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript']
    };

    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    setTextTemplate()

                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        setTextTemplate()

                    }}>
                    {!!isEdit ? props.t("Edit Horizontal Text") : props.t("Add Horizontal Text")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        {/* <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Schor Concept id")}: </Label>
                            <span style={{ fontSize: "15px", fontWeight: "bold" }}> {state?.horizontalSchorData?.question}</span>
                        </div> */}



                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language")}:</Label>
                            <Input
                                name="language"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.language || ""}
                                invalid={
                                    validation.touched.language && validation.errors.language ? true : false
                                }
                            >
                                <option value="" disabled>{props.t("Select Language")}</option>
                                {
                                    languageList?.map((data, key) => {
                                        return (
                                            <option key={key} value={data?.id}>{data?.label}</option>
                                        )
                                    })
                                }
                            </Input>
                            {validation.touched.language && validation.errors.language ? (
                                <FormFeedback type="invalid">{validation.errors.language}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3 d-block">

                            <Label className="form-label m-0 pb-1">{props.t("Text")}:</Label>

                            <CKEditor
                                config={editorConfiguration}
                                editor={ClassicEditor}
                                data={horizontalSchorTextData?.text ? horizontalSchorTextData?.text : ""}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setTextTemplate(data)
                                }}
                            />
                        </div>
                        {/* <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y' ? true : false}
                                    value="Y"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N' ? true : false}
                                    value="N"
                                    type="radio"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div> */}

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }

                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


TextAddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(TextAddEditModal);
